<div class="dir-wrapper" [dir]="dir">
  <router-outlet></router-outlet>
  <app-coach-window />
  <div class="build-info" [hidden]="!buildInfoVisible">{{buildInfo}}</div>
  <div igxOverlayOutlet #overlay="overlay-outlet"></div>
</div>
